var _createClass = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/createClass.js").default;

var _classCallCheck = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/hooks"] = t() : (e.wp = e.wp || {}, e.wp.hooks = t());
}(self, function () {
  return function () {
    var e = {
      424: function _(e) {
        e.exports = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      975: function _(e, t, r) {
        "use strict";

        var o = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var n = o(r(62)),
            i = o(r(700));

        var s = function createAddHook(e, t) {
          return function addHook(r, o, s) {
            var l = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 10;
            var u = e[t];
            if (!(0, i.default)(r)) return;
            if (!(0, n.default)(o)) return;
            if ("function" != typeof s) return void console.error("The hook callback must be a function.");
            if ("number" != typeof l) return void console.error("If specified, the hook priority must be a number.");
            var a = {
              callback: s,
              priority: l,
              namespace: o
            };

            if (u[r]) {
              var _e = u[r].handlers;

              var _t;

              for (_t = _e.length; _t > 0 && !(l >= _e[_t - 1].priority); _t--) {
                ;
              }

              _t === _e.length ? _e[_t] = a : _e.splice(_t, 0, a), u.__current.forEach(function (e) {
                e.name === r && e.currentIndex >= _t && e.currentIndex++;
              });
            } else u[r] = {
              handlers: [a],
              runs: 0
            };

            "hookAdded" !== r && e.doAction("hookAdded", r, o, s, l);
          };
        };

        t.default = s;
      },
      790: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;

        var r = function createCurrentHook(e, t) {
          return function currentHook() {
            var r, o;
            var n = e[t];
            return null !== (r = null === (o = n.__current[n.__current.length - 1]) || void 0 === o ? void 0 : o.name) && void 0 !== r ? r : null;
          };
        };

        t.default = r;
      },
      279: function _(e, t, r) {
        "use strict";

        var o = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var n = o(r(700));

        var i = function createDidHook(e, t) {
          return function didHook(r) {
            var o = e[t];
            if ((0, n.default)(r)) return o[r] && o[r].runs ? o[r].runs : 0;
          };
        };

        t.default = i;
      },
      701: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;

        var r = function createDoingHook(e, t) {
          return function doingHook(r) {
            var o = e[t];
            return void 0 === r ? void 0 !== o.__current[0] : !!o.__current[0] && r === o.__current[0].name;
          };
        };

        t.default = r;
      },
      354: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;

        var r = function createHasHook(e, t) {
          return function hasHook(r, o) {
            var n = e[t];
            return void 0 !== o ? r in n && n[r].handlers.some(function (e) {
              return e.namespace === o;
            }) : r in n;
          };
        };

        t.default = r;
      },
      568: function _(e, t, r) {
        "use strict";

        var o = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = t._Hooks = void 0;
        var n = o(r(975)),
            i = o(r(805)),
            s = o(r(354)),
            l = o(r(455)),
            u = o(r(790)),
            a = o(r(701)),
            d = o(r(279));

        var _Hooks = /*#__PURE__*/_createClass(function _Hooks() {
          _classCallCheck(this, _Hooks);

          this.actions = Object.create(null), this.actions.__current = [], this.filters = Object.create(null), this.filters.__current = [], this.addAction = (0, n.default)(this, "actions"), this.addFilter = (0, n.default)(this, "filters"), this.removeAction = (0, i.default)(this, "actions"), this.removeFilter = (0, i.default)(this, "filters"), this.hasAction = (0, s.default)(this, "actions"), this.hasFilter = (0, s.default)(this, "filters"), this.removeAllActions = (0, i.default)(this, "actions", !0), this.removeAllFilters = (0, i.default)(this, "filters", !0), this.doAction = (0, l.default)(this, "actions"), this.applyFilters = (0, l.default)(this, "filters", !0), this.currentAction = (0, u.default)(this, "actions"), this.currentFilter = (0, u.default)(this, "filters"), this.doingAction = (0, a.default)(this, "actions"), this.doingFilter = (0, a.default)(this, "filters"), this.didAction = (0, d.default)(this, "actions"), this.didFilter = (0, d.default)(this, "filters");
        });

        t._Hooks = _Hooks;

        var c = function createHooks() {
          return new _Hooks();
        };

        t.default = c;
      },
      805: function _(e, t, r) {
        "use strict";

        var o = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var n = o(r(62)),
            i = o(r(700));

        var s = function createRemoveHook(e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          return function removeHook(o, s) {
            var l = e[t];
            if (!(0, i.default)(o)) return;
            if (!r && !(0, n.default)(s)) return;
            if (!l[o]) return 0;
            var u = 0;
            if (r) u = l[o].handlers.length, l[o] = {
              runs: l[o].runs,
              handlers: []
            };else {
              var _e2 = l[o].handlers;

              var _loop = function _loop(_t2) {
                _e2[_t2].namespace === s && (_e2.splice(_t2, 1), u++, l.__current.forEach(function (e) {
                  e.name === o && e.currentIndex >= _t2 && e.currentIndex--;
                }));
              };

              for (var _t2 = _e2.length - 1; _t2 >= 0; _t2--) {
                _loop(_t2);
              }
            }
            return "hookRemoved" !== o && e.doAction("hookRemoved", o, s), u;
          };
        };

        t.default = s;
      },
      455: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;

        var r = function createRunHook(e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          return function runHooks(o) {
            var n = e[t];
            n[o] || (n[o] = {
              handlers: [],
              runs: 0
            }), n[o].runs++;
            var i = n[o].handlers;

            for (var s = arguments.length, l = new Array(s > 1 ? s - 1 : 0), u = 1; u < s; u++) {
              l[u - 1] = arguments[u];
            }

            if (!i || !i.length) return r ? l[0] : void 0;
            var a = {
              name: o,
              currentIndex: 0
            };

            for (n.__current.push(a); a.currentIndex < i.length;) {
              var _e3 = i[a.currentIndex].callback.apply(null, l);

              r && (l[0] = _e3), a.currentIndex++;
            }

            return n.__current.pop(), r ? l[0] : void 0;
          };
        };

        t.default = r;
      },
      700: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;

        var r = function validateHookName(e) {
          return "string" != typeof e || "" === e ? (console.error("The hook name must be a non-empty string."), !1) : /^__/.test(e) ? (console.error("The hook name cannot begin with `__`."), !1) : !!/^[a-zA-Z][a-zA-Z0-9_.-]*$/.test(e) || (console.error("The hook name can only contain numbers, letters, dashes, periods and underscores."), !1);
        };

        t.default = r;
      },
      62: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;

        var r = function validateNamespace(e) {
          return "string" != typeof e || "" === e ? (console.error("The namespace must be a non-empty string."), !1) : !!/^[a-zA-Z][a-zA-Z0-9_.\-\/]*$/.test(e) || (console.error("The namespace can only contain numbers, letters, dashes, periods, underscores and slashes."), !1);
        };

        t.default = r;
      }
    },
        t = {};

    function __webpack_require__(r) {
      var o = t[r];
      if (void 0 !== o) return o.exports;
      var n = t[r] = {
        exports: {}
      };
      return e[r](n, n.exports, __webpack_require__), n.exports;
    }

    var r = {};
    return function () {
      "use strict";

      var e = r,
          t = __webpack_require__(424);

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.applyFilters = e.addFilter = e.addAction = e.actions = void 0, Object.defineProperty(e, "createHooks", {
        enumerable: !0,
        get: function get() {
          return o.default;
        }
      }), e.removeFilter = e.removeAllFilters = e.removeAllActions = e.removeAction = e.hasFilter = e.hasAction = e.filters = e.doingFilter = e.doingAction = e.doAction = e.didFilter = e.didAction = e.defaultHooks = e.currentFilter = e.currentAction = void 0;
      var o = t(__webpack_require__(568));
      var n = (0, o.default)();
      e.defaultHooks = n;
      var i = n.addAction,
          s = n.addFilter,
          l = n.removeAction,
          u = n.removeFilter,
          a = n.hasAction,
          d = n.hasFilter,
          c = n.removeAllActions,
          f = n.removeAllFilters,
          h = n.doAction,
          v = n.applyFilters,
          _ = n.currentAction,
          p = n.currentFilter,
          m = n.doingAction,
          A = n.doingFilter,
          k = n.didAction,
          b = n.didFilter,
          y = n.actions,
          F = n.filters;
      e.filters = F, e.actions = y, e.didFilter = b, e.didAction = k, e.doingFilter = A, e.doingAction = m, e.currentFilter = p, e.currentAction = _, e.applyFilters = v, e.doAction = h, e.removeAllFilters = f, e.removeAllActions = c, e.hasFilter = d, e.hasAction = a, e.removeFilter = u, e.removeAction = l, e.addFilter = s, e.addAction = i;
    }(), r;
  }();
});